<template>
  <res-dialog 
    :showDialog="showDialog"
    :title="dialogTitle"
    :smallTitleIcon="true"
    :cancelButtonOnly="true"
    :cancelButtonTextColor="'primary--text'"
    :cancelButtonColor="'primary'"
    :cancelButtonText="buttonText"
    :cancelButtonWidth="'80'"
    :iconColor="'white'"
    :iconTitle="dialogIconCode"
    :showTitleIcon="true"
    :titleClass="titleClass"
    @cancel="closeErrorDialog">
    <v-card-text>
      <span>
        {{ dialogMessage }}
      </span>
      <slot></slot>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import {Constants} from '@/utilities/constants/index.js';
  import {mapGetters, mapActions} from 'vuex'

  export default {
    components: {
      ResDialog
    },
    data: function () {
      return {};
    },
    methods: {
      ...mapActions(['deactivateErrorDialog']),
      closeErrorDialog() {
        if (this.currentErrorDialogCallback) {
          this.currentErrorDialogCallback(this.currentErrorDialogCallbackParams);
        }
        this.deactivateErrorDialog();
      }
    },
    computed: {
      ...mapGetters([
        'currentErrorDialogIsActive',
        'currentErrorDialogSeverity',
        'currentErrorDialogMessage', 
        'currentErrorDialogTitle', 
        'currentErrorDialogIconCode', 
        'currentErrorDialogCallback', 
        'currentErrorDialogCallbackParams'
      ]),
      showDialog() {
        return this.currentErrorDialogIsActive;
      },
      dialogMessage() {
        return this.currentErrorDialogMessage;
      },
      dialogTitle() {
        return this.currentErrorDialogTitle;
      },
      dialogSeverity() {
        return this.currentErrorDialogSeverity;
      },
      dialogIconCode() {
        return this.currentErrorDialogIconCode;
      },
      buttonText() {
        return 'OK';
      },
      titleClass() {
        switch (this.dialogSeverity)
        {
          case Constants.DIALOG_SEVERITY_WARNING:
          case Constants.DIALOG_SEVERITY_INFO:
            return 'resBlue darken-1 white--text';
          default:
            return 'resRed darken-1 white--text';
        }
      }
    }
  }
</script>
